import Vue from 'vue';
import VueRouter from 'vue-router';

import prodfileRoutes from './prodfile';
import designfileRoutes from './designfile';
import orderRoutes from './order';

// admin
import accessoryRoutes from './accessory';
import controlunitRoutes from './controlunit';
import customerRoutes from './customer';
import designfiletypeRoutes from './designfiletype';
import industrialcomputerRoutes from './industrialcomputer';
import machineRoutes from './machine';
import materialRoutes from './material';
import nozzleRoutes from './nozzle';
import orderstateRoutes from './orderstate';
import ordertypeRoutes from './ordertype';
import orderresolutionRoutes from './orderresolution';
import actiontypeRoutes from './actiontype';
import printingsurfaceRoutes from './printingsurface';
import printerRoutes from './printer';
import priorityRoutes from './priority';
import sectorRoutes from './sector';
import tagRoutes from './tag';
import toolrefRoutes from './toolref';
import toolheadRoutes from './toolhead';
import updatedlynxapiRoutes from './updatedlynxapi';
import riskRoutes from './risk';
import verticaleRoutes from './verticale';


//user
import userRoutes from './user';
import forgotpasswordRoutes from './forgotpassword';
import connexionuserRoutes from './connexionuser';
import homeRoutes from './home';
import loginRoutes from './login';
import profilRoutes from './profil';
import notificationRoutes from './notification';
import profiluserRoutes from './profiluser';
import profilinterfaceRoutes from './profilinterface';
import securityparameterRoutes from './securityparameter';
import backupRoutes from './backup';
import orderactionRoutes from './orderaction';


Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [
        prodfileRoutes,
        designfileRoutes,
        orderRoutes,
        orderactionRoutes,
        actiontypeRoutes,

        accessoryRoutes,
        controlunitRoutes,
        customerRoutes,
        designfiletypeRoutes,
        industrialcomputerRoutes,
        machineRoutes,
        materialRoutes,
        nozzleRoutes,
        orderstateRoutes,
        ordertypeRoutes,
        orderresolutionRoutes,
        printingsurfaceRoutes,
        riskRoutes,
        printerRoutes,
        priorityRoutes,
        sectorRoutes,
        tagRoutes,
        toolrefRoutes,
        toolheadRoutes,
        updatedlynxapiRoutes,
        verticaleRoutes,

        userRoutes,
        forgotpasswordRoutes,
        connexionuserRoutes,
        profiluserRoutes,
        securityparameterRoutes,
        homeRoutes,
        loginRoutes,
        profilRoutes,
        profilinterfaceRoutes,
        notificationRoutes,
        backupRoutes
    ]
});
